import React from 'react';
import QuestionToggle from './QuestionToggle';

function AccordionPanel({ data, isOpen = false, onToggle }) {
    const title = data.title;
    const questions = data.questions;

    return (
        <div className={`accordion-panel ${isOpen ? 'open' : 'closed'}`}>
            <button className="panel-toggle" onClick={onToggle}>
                {title}

                {isOpen ? (
                    <svg className="panel-toggle-icon toggle-opened-icon" xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none">
                        <path d="M2.8125 5.55566C2.50184 5.55566 2.25 5.8075 2.25 6.11816C2.25 6.42882 2.50184 6.68066 2.8125 6.68066L9.1875 6.68066C9.49816 6.68066 9.75 6.42882 9.75 6.11816C9.75 5.8075 9.49816 5.55566 9.1875 5.55566H2.8125Z" fill="#1A0F33"/>
                    </svg>
                ) : (
                    <svg className="panel-toggle-icon toggle-closed-icon" xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none">
                        <path d="M6.9 1.51816C6.9 1.02111 6.49706 0.618164 6 0.618164C5.50294 0.618164 5.1 1.02111 5.1 1.51816V5.71816H0.9C0.402944 5.71816 0 6.12111 0 6.61816C0 7.11522 0.402944 7.51816 0.9 7.51816L5.1 7.51816V11.7182C5.1 12.2152 5.50294 12.6182 6 12.6182C6.49706 12.6182 6.9 12.2152 6.9 11.7182V7.51816L11.1 7.51817C11.5971 7.51817 12 7.11522 12 6.61816C12 6.12111 11.5971 5.71816 11.1 5.71816H6.9V1.51816Z" fill="#7B7D80"/>
                    </svg>
                )}
            </button>
            <div className="panel-collapse">
                {questions.map((question, index) => (
                    <QuestionToggle key={index} question={question} />
                ))}
            </div>
        </div>
    );
}

export default AccordionPanel;
